import { ButtonBase } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

import Logo from 'components/ui/Logo';

const useStyles = makeStyles()(() => ({
  logo: {
    maxWidth: '150px'
  }
}));

const LogoSection = () => {
  const { classes } = useStyles();

  return (
    <ButtonBase disableRipple>
      <Logo className={classes.logo} />
    </ButtonBase>
  );
};

export default LogoSection;
